// extracted by mini-css-extract-plugin
export default {"root":"NewsPage_root__OHKU2"};